import axiosInstance from '../../services/axiosInstance';

export const getAllPackages = async () => {
  try {
    const response = await axiosInstance.get('/packages');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getServicePackages = async (serviceName: string) => {
  try {
    const response = await axiosInstance.get(`/packages`, {
        params: {
            service_name: serviceName,
            skip: 0,
            limit: 100
        }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createPackage = async (packageData: any) => {
    try {
        const response = await axiosInstance.post('/package', packageData);
        console.log("Package created successfully:", response.data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updatePackage = async (packageData: any) => {
    try {
        const response = await axiosInstance.post(`/update-package`, packageData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const deletePackage = async (packageId: string) => {
    try {
        const response = await axiosInstance.delete(`${packageId}/package`);
        return response.data;
    } catch (error) {
        throw error;
    }
};